import { IPlantillaVerificacion } from "../../../Interfaces/IPlantillaVerificacion"
import { IButtonGroup } from "../../../Interfaces/filter"
import { TableBaseComponent } from "../../../components/Table/TableBaseComponent"
import { TableComponent } from "../../../components/Table/TableComponent"
import Estado from "../../../components/elements/Estado"
import { UsePersonaCheckList } from "./UsePersonaCheckList"



export interface IPersonaCheckList{
    personaId:string
}
export const PersonaCheckList=(props:IPersonaCheckList)=>{
    const {filter,setFilter,items,loading,pagination,handleResetUpdate} = UsePersonaCheckList(props)
    const buttonLeft: IButtonGroup[] = [
         {
              onClick: () => {
                handleResetUpdate();
              },
              text: "Actualizar",
        },
    ];
    const _columns = [
        {
          key: "nombre",
          name: "Nombre",
          fieldName: "nombre",
          minWidth: 100,
          maxWidth: 300,  
          
        },
        {
          key: "estado",
          name: "Estado",
          fieldName: "estado",
          minWidth: 100,
          maxWidth: 300,  
          
          onRender: (item: IPlantillaVerificacion) => (
            <Estado value={item.activo ? "Inactivo" : "Activo"} />
          ),
        },
        {
          key: "modeloEquipo",
          name: "Modelo Equipo",
          fieldName: "equipoModelo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          key: "fechaCreacion",
          name: "Fecha Creacion",
          fieldName: "fechaCreacion",
          minWidth: 100,
          maxWidth: 200,
        },
      
      ];
    return(
        <>
        <TableComponent column={_columns} data={items} isLoading={loading} paginacion={pagination} leftButtons={buttonLeft}/>
        </>
    )
}